import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '@/context/LanguageContext';
import { useServices } from '@/context/ServicesContext';
import { Mail, Phone, MapPin } from 'lucide-react';
import { LogoMark } from '@/components/Logo';

export default function Footer() {
  const { t, tv } = useLang();
  const { services } = useServices();
  return (
    <footer className="relative z-10 border-t border-[color:var(--itw-border)] bg-[color:var(--itw-surface)] mt-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <LogoMark size={40} glow />
              <span className="font-display font-semibold text-lg text-[color:var(--itw-text)]">IT-WELT<span className="text-[color:var(--itw-cyan)]">360</span></span>
            </div>
            <p className="mt-4 text-sm text-[color:var(--itw-text-2)] max-w-xs">{t('footer.tagline')}</p>
          </div>
          <div>
            <h4 className="font-display text-sm font-semibold text-[color:var(--itw-text)] mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s.slug}><Link to={`/leistungen/${s.slug}`} className="text-sm text-[color:var(--itw-text-2)] hover:text-[color:var(--itw-cyan)] transition-colors">{tv(s.name)}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-semibold text-[color:var(--itw-text)] mb-4">{t('footer.company')}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/ueber-uns" className="text-sm text-[color:var(--itw-text-2)] hover:text-[color:var(--itw-cyan)] transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/kontakt" className="text-sm text-[color:var(--itw-text-2)] hover:text-[color:var(--itw-cyan)] transition-colors">{t('nav.contact')}</Link></li>
              <li><Link to="/login" className="text-sm text-[color:var(--itw-text-2)] hover:text-[color:var(--itw-cyan)] transition-colors">{t('nav.portal')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-semibold text-[color:var(--itw-text)] mb-4">{t('footer.legal')}</h4>
            <ul className="space-y-2.5 text-sm text-[color:var(--itw-text-2)]">
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[color:var(--itw-cyan)]" /> info@it-welt360.de</li>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[color:var(--itw-cyan)]" /> +49 (0) 800 360 360</li>
              <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[color:var(--itw-cyan)]" /> Deutschland</li>
            </ul>
          </div>
        </div>
        <div className="cyan-divider my-8" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[color:var(--itw-text-3)]">
          <span>© {new Date().getFullYear()} IT-WELT360. {t('footer.rights')}</span>
          <div className="flex gap-5">
            <span className="hover:text-[color:var(--itw-text-2)] cursor-pointer transition-colors">{t('footer.imprint')}</span>
            <span className="hover:text-[color:var(--itw-text-2)] cursor-pointer transition-colors">{t('footer.privacy')}</span>
            <span className="hover:text-[color:var(--itw-text-2)] cursor-pointer transition-colors">{t('footer.terms')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
